import { render, staticRenderFns } from "./SelectCompetency.vue?vue&type=template&id=a0d8b9b4&scoped=true&"
import script from "./SelectCompetency.vue?vue&type=script&lang=js&"
export * from "./SelectCompetency.vue?vue&type=script&lang=js&"
import style0 from "./SelectCompetency.vue?vue&type=style&index=0&id=a0d8b9b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d8b9b4",
  null
  
)

export default component.exports